import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@vd/ui/styles.css';
import './styles/globals.css';
import { App } from './App';

async function enableMocksIfRequested() {
  if (import.meta.env.VITE_USE_MSW !== '1') return;
  // Hard guard against MSW running in production. We've crashed prod
  // by leaving VITE_USE_MSW=1 in a build env once before; this throws
  // on app boot rather than silently intercepting real requests.
  if (import.meta.env.PROD) {
    throw new Error('VITE_USE_MSW=1 must not be set in a production build.');
  }
  const { worker } = await import('./test/msw-browser');
  await worker.start({
    onUnhandledRequest: 'bypass',
    serviceWorker: { url: '/mockServiceWorker.js' },
  });
}

enableMocksIfRequested().then(() => {
  const root = document.getElementById('root');
  if (!root) throw new Error('Missing #root element');
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
